export { default } from './cookie-content';
